import { inject, observer } from 'mobx-react';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { Category } from 'shared/utils/flowstep';
import Context from 'src/components/Context';
import Flows from 'src/components/Flows';
import Flowsteps from 'src/components/Flowsteps';
import Home from 'src/components/Home';
import Scheduler from 'src/components/Scheduler';
import Navigation from 'src/containers/Navigation';


import { HubspotHome } from '@v2/hubspot/HubspotHome/HubspotHome';
import { AccountType } from 'shared/types/flowstep';

export const Path = {
  Home1: `/home/${Category.Pull}`,
  Home2: `/home/${Category.Push}`,
  Flow: `/home/flows`,
  Flowstep: `/home/flowsteps`,
  Scheduler: '/home/scheduler',
  Context: '/home/context',
};

export default inject('userStore')(observer((props) => {
  const userStore = props.userStore
  const {
    scheduler: { seeTab: seeSchedulerTab },
    flows: { seeTab: seeFlowsTab },
    home: { seeTab: seeHomeTab }
  } = userStore.license;

  const match = useRouteMatch();


  const isHomeAvailable = () => seeHomeTab.can;
  const isFlowsAvailable = () => seeFlowsTab.can;
  const isFlowstepsAvailable = () => seeFlowsTab.can || seeHomeTab.can;
  const isSchedulerAvailable = () => seeSchedulerTab.can;


  const getFirstAvailableRoute = () => {
    if (isHomeAvailable()) return Path.Home1;
    if (isFlowsAvailable()) return Path.Flow;
    if (isFlowstepsAvailable()) return Path.Flowstep;
    if (isSchedulerAvailable()) return Path.Scheduler;
    return Path.Context;
  };

  return (
    <>
      <Navigation />
      <Switch>
        {isHomeAvailable() && userStore.accountType === AccountType.SF && <Route path={[
          `${match.path}/pull/salesforce`,
          `${match.path}/push/salesforce`
        ]} component={Home} />}
        {isHomeAvailable() && userStore.accountType === AccountType.HS && <Route path={[
          `${match.path}/pull/hubspot`,
          `${match.path}/push/hubspot`
        ]} component={HubspotHome} />}
        {isFlowstepsAvailable() && <Route path={Path.Flowstep} component={Flowsteps} />}

        <Route path={Path.Context} component={Context} />
        {isSchedulerAvailable() && <Route path={Path.Scheduler} component={Scheduler} />}
        {isFlowsAvailable() && <Route path={Path.Flow} component={Flows} />}

        {isHomeAvailable() &&
          <>
            <Redirect exact from={Path.Home1} to={`${match.path}/pull/${userStore.accountType}`} />
            <Redirect exact from={Path.Home2} to={`${match.path}/pull/${userStore.accountType}`} />
          </>
        }
        <Redirect to={getFirstAvailableRoute()} />
      </Switch>
    </>
  );
}));
